import { useContext, useState } from 'react';
import { ChatTaskContext } from 'react-scale/components/scalers/tasks/ThreadedInteraction/contexts/ChatTaskContext';
import { ChatMessageDisplayType } from '@scale/shared/types/chat';

export type ChatMessageDisplayConfig = {
  displayType: ChatMessageDisplayType;
  markdownConfig: {
    enableMathPlugin: boolean;
    enableSingleDollarTextMath: boolean;
  };
};

export const useConfigureChatMessageDisplay = (
  initialState?: Partial<ChatMessageDisplayConfig>,
) => {
  const taskContext = useContext(ChatTaskContext);

  const [chatMessageDisplayConfig, setChatMessageDisplayConfig] =
    useState<ChatMessageDisplayConfig>({
      displayType: initialState?.displayType ?? ChatMessageDisplayType.Markdown,
      markdownConfig: {
        enableMathPlugin:
          initialState?.markdownConfig?.enableMathPlugin ??
          !!taskContext.milkdownEditorConfig?.enableMathPlugin,
        enableSingleDollarTextMath:
          initialState?.markdownConfig?.enableSingleDollarTextMath ??
          !!taskContext.milkdownEditorConfig?.enableSingleDollarTextMath,
      },
    });

  const toggleChatMessageDisplayType = () => {
    setChatMessageDisplayConfig(prev => ({
      ...prev,
      displayType:
        prev.displayType === ChatMessageDisplayType.Markdown
          ? ChatMessageDisplayType.Plaintext
          : ChatMessageDisplayType.Markdown,
    }));
  };

  const updateMarkdownConfig = (config: Partial<ChatMessageDisplayConfig['markdownConfig']>) => {
    setChatMessageDisplayConfig(prev => ({
      ...prev,
      markdownConfig: {
        ...prev.markdownConfig,
        ...config,
      },
    }));
  };

  return {
    useMarkdownDisplay: chatMessageDisplayConfig.displayType === ChatMessageDisplayType.Markdown,
    chatMessageDisplayConfig,
    updateMarkdownConfig,
    toggleChatMessageDisplayType,
  };
};
